export const extraMessageErrorSendForSignature = '';
